@if (HasRequiredPermissions) {
@if (hasWebSocketChanges()) {
<div class="absolute top-[3.2em] right-[1.5em] px-3 py-0 bg-yellow-50 border border-yellow-500 rounded-lg flex items-center justify-between z-50">
  <span class="text-xs text-yellow-800">
    {{ 'Record ' | translate }} {{ 'modified' | translate }}.
    ({{ totalModifiedCount() }} {{ 'changes' | translate }})
  </span>
</div>
}
@if (EntityInstance || isNew()) {
<div [fieldContext]="this" class="flex flex-col h-full">
  <!-- Titre -->
  <div class="px-6 pt-4 pb-2">
    <h4 class="text-[0.9em] font-medium text-gray-500 z-[999]">
      @if (isNew()) {
      {{ 'entities.visit.newEntity' | translate }}
      } @else {
      {{ 'entities.visit.detailEntity' | translate }}
      }
    </h4>
    <div class="flex justify-between items-center">
      <button (click)="cancelEdit()" data-testid="detail-close" class="absolute top-2 right-2 text-gray-500 hover:text-gray-700 transition-colors">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  </div>
  <!-- Zone de contenu -->
  <div #scrollContainer class="{{Skin.detailContainer}} flex-1 overflow-auto">
    <div class="{{this.UpdateMode}}">
      <!-- Section Personal infos -->
      <h3 class="{{Skin.formSectionSmallTitle}}">
        <i class="fas fa-user mr-2"></i> {{ 'vues.visit.detail.sections.personal-info' | translate }}
      </h3>
      <div class="space-y-2">
        <!-- Photo Upload (spécifique) -->
        <div class="relative m-6 w-[140px] h-[180px] mt-2 ml-16 border border-gray-300 overflow-hidden rounded-[10px] border-[3px] border-gray-100 shadow-[0_7px_7px_rgba(0,0,0,0.1)]">
          <i class="far fa-user absolute inset-0 text-gray-400 text-[120px] flex items-center justify-center pointer-events-none" [ngClass]="{'hidden': imageUrl}"></i>
          <img [src]="imageUrl || ''" class="w-full h-full object-cover" [ngClass]="{'hidden': !imageUrl}" />
          <div class="absolute bottom-0 left-0 flex">
            <input type="file" #fileInput accept="image/*" (change)="onFileSelected($event,'imagePhoto.thumbnail_Path')" class="hidden" />
            <button type="button" (click)="fileInput.click()" class="bg-teal-500 hover:bg-teal-800 text-white px-2 py-1 text-xs font-xs">
              <i class="fa fa-camera text-[0.9rem]"></i>
            </button>
            <button type="button" (click)="resetImage()" class="{{Skin.btnAlert}} px-2 py-1 text-xs font-xs">
              <i class="fas fa-times text-[0.9rem]"></i>
            </button>
          </div>
        </div>
        <!-- Champ selectedPK_Pos (multi-select) -->
        <app-field-wrapper property="selectedPK_Pos" businessProperty="fK_POS" label="entities.account.propreties.pos">
          <app-multi-select #multiSelect1
            [options]="pointOfServiceLookup()"
            [placeholder]="'Select Sites'"
            [maxItems]="1"
            [isMultiselect]="false"
            [selectedKeys]="editingEntity()?.selectedPK_Pos ?? []"
            (selectedKeysChange)="onPOSselectChange($event)"
            onReady
            (autoBind)="bindingHandler($event, 'selectedPK_Pos', multiSelect1)">
          </app-multi-select>
        </app-field-wrapper>
        <fieldset [disabled]="!editingEntity()?.selectedPK_Pos?.length" class="border-none p-0 m-0">
          <div [class.opacity-60]="!editingEntity()?.selectedPK_Pos?.length" [class.pointer-events-none]="!editingEntity()?.selectedPK_Pos?.length" class="{{this.UpdateMode}}">
            <!-- ID (visitId) - lecture seule -->
            <app-field-wrapper property="visitId">
              <input type="text" readonly
                [readonly]="true"
                onReady
                class="{{Skin.formInputSmallSize}} w-full border border-gray-400 p-2 rounded-[6px] bg-gray-100  readonly:pointer-events-none "
                (autoBind)="bindingHandler($event, 'visitId')">
            </app-field-wrapper>
            <!-- Full Name (visitor.fullname) -->
            <app-field-wrapper property="visitor.fullname" label="full-name">
              <input type="text"
                autocomplete="off"
                onReady
                [readonly]="!isEditMode()"

                class="{{Skin.formInputSmallSize}} w-full border border-gray-400 p-2 rounded-[6px]"
                (autoBind)="bindingHandler($event, 'visitor.fullname', null, 'visitor')">
            </app-field-wrapper>
            <!-- Email (visitor.email) -->
            <app-field-wrapper property="visitor.email" label="Email">
              <input type="email"
                autocomplete="off"
                [readonly]="!isEditMode()"
                onReady

                class="{{Skin.formInputSmallSize}} w-full border border-gray-400 p-2 rounded-[6px]"
                (autoBind)="bindingHandler($event, 'visitor.email', null, 'visitor')">
            </app-field-wrapper>
            <!-- Phone (visitor.phoneNumber) -->
            <app-field-wrapper property="visitor.phoneNumber" label="phone-number">
              <input type="tel" autocomplete="off"
                [readonly]="!isEditMode()"
                onReady

                class="{{Skin.formInputSmallSize}} w-full border border-gray-400 p-2 rounded-[6px]"
                (autoBind)="bindingHandler($event, 'visitor.phoneNumber', null, 'visitor')">
            </app-field-wrapper>
            <!-- Company -->
            <app-field-wrapper property="company">
              <input type="text" autocomplete="off" onReady [readonly]="!isEditMode()"

                class="{{Skin.formInputSmallSize}} w-full border border-gray-400 p-2 rounded-[6px]"
                (autoBind)="bindingHandler($event, 'company')">
            </app-field-wrapper>
          </div>
        </fieldset>
      </div>
      <fieldset [disabled]="!editingEntity()?.selectedPK_Pos?.length" class="border-none p-0 m-0">
        <div [class.opacity-60]="!editingEntity()?.selectedPK_Pos?.length" [class.pointer-events-none]="!editingEntity()?.selectedPK_Pos?.length" class="{{this.UpdateMode}}">
          <!-- Section Visitor infos -->
          <h3 class="{{Skin.formSectionSmallTitle}} mt-6">
            <i class="fas fa-info-circle mr-2"></i> {{ 'vues.visit.detail.sections.visitor-infos' | translate }}
          </h3>
          <div class="space-y-2">
            <!-- Start Date -->
            <app-field-wrapper property="startDate">
              <app-date-time-picker onReady
                [siteTimeZone]="fuseauDuSite"
                [selectedDateTime]="editingEntity()?.startDate ?? null"
                [calendarAlign]="'bottom-left'"
                [disabled]="!editingEntity()?.selectedPK_Pos?.length || !isPosSelected()"
                (dateTimeChange)="onDateTimePropretyChange($event, 'startDate')"
                class="{{Skin.formInputSmallSize}} block bg-white"
                (autoBind)="bindingHandler($event, 'startDate')">
              </app-date-time-picker>
            </app-field-wrapper>
            <!-- End Date -->
            <app-field-wrapper property="endDate">
              <app-date-time-picker onReady
                [siteTimeZone]="fuseauDuSite"
                [selectedDateTime]="editingEntity()?.endDate ?? null"
                [calendarAlign]="'bottom-left'"
                [disabled]="!editingEntity()?.selectedPK_Pos?.length || !isPosSelected()"
                (dateTimeChange)="onDateTimePropretyChange($event, 'endDate')"
                class="{{Skin.formInputSmallSize}} block bg-white"
                (autoBind)="bindingHandler($event, 'endDate')">
              </app-date-time-picker>
            </app-field-wrapper>
            <!-- Status -->
            <app-field-wrapper property="status">
              <app-reactive-badge [status]="$safeNavigationMigration(editingEntity()?.status)"
                [lookupData]="visitStatusLookup()"
                [Skin]="Skin"
                [isEditMode]="true"
                (statusChange)="onStatusChange($event)">
              </app-reactive-badge>
            </app-field-wrapper>
            <!-- Suggestion (readonly, from feedback) -->
            <app-field-wrapper property="suggestion" label="vues.visit.detail.suggestion">
              <div class="flex items-center justify-center h-full">
                <app-bubble-smiley [score]="1"
                  [class]="suggestion() == '1' ? 'opacity-100 mr-10': 'opacity-30 mr-4'"
                  [showAsBubble]="false"
                  [comment]="comments()||''"
                  (click)="updateFeedbackScore(1)"
                  [showCommentInTooltip]="true"
                  [size]="suggestion() == '1'? 'w-[70px] h-[70px]': 'w-[70px] h-[50px]'"
                  [showAsSelected]="suggestion() == '1'">
                </app-bubble-smiley>
                <app-bubble-smiley [score]="2"
                  [class]="suggestion()== '2'? 'opacity-100 mr-10': 'opacity-30 mr-4'"
                  [showAsBubble]="false"
                  [comment]="comments()||''"
                  (click)="updateFeedbackScore(2)"
                  [showCommentInTooltip]="true"
                  [size]="suggestion()== '2'? 'w-[70px] h-[70px]': 'w-[70px] h-[50px]'"
                  [showAsSelected]="suggestion()== '2'">
                </app-bubble-smiley>
                <app-bubble-smiley [score]="3"
                  [class]="suggestion()== '3'? 'opacity-100 mr-10': 'opacity-30 mr-4'"
                  [showAsBubble]="false"
                  [comment]="comments()||''"
                  (click)="updateFeedbackScore(3)"
                  [showCommentInTooltip]="true"
                  [size]="suggestion()== '3'? 'w-[70px] h-[70px]': 'w-[70px] h-[50px]'"
                  [showAsSelected]="suggestion()== '3'">
                </app-bubble-smiley>
              </div>
            </app-field-wrapper>
            <!-- Comments (from feedback) -->
            <app-field-wrapper property="comments" label="vues.visit.detail.comments">
              <textarea [readonly]="!isEditMode()"
                [ngModel]="comments()"
                (ngModelChange)="updateFeedbackComment($event)"
                class="w-full border border-gray-400 p-2 rounded-[6px]"
                [class]="isEditMode() ? Skin.formInputSmallSize : Skin.formInputSmallSize + ' bg-gray-100'"
                rows="3"></textarea>
            </app-field-wrapper>
            <!-- Visitor Type (dropdown) -->
            <app-field-wrapper property="visitorType">
              <select onReady
                [disabled]="!isEditMode()"

                class="{{Skin.formInputSmallSize}} w-full border border-gray-400 p-2 rounded-[6px]"
                (autoBind)="bindingHandler($event, 'visitorType')">
                <option [value]="null" disabled>{{ 'choose-a-type' | translate }}</option>
                @for (type of visitorTypeOptions; track type.key) {
                <option [value]="type.key">{{ type.value | translate }}</option>
                }
              </select>
            </app-field-wrapper>
            <!-- Visited Person (employeeName)  -->
            <app-field-wrapper property="selectedPK_Employee" businessProperty="fK_Employee" label="entities.visit.propreties.visitedPerson">
              <app-multi-select #multiSelect2
                [options]="filteredEmployeeLookup()"
                [placeholder]="'choose-employee'"
                [maxItems]="1"
                [isMultiselect]="false"
                [selectedKeys]="editingEntity()?.selectedPK_Employee ?? []"
                (selectedKeysChange)="onHostselectChange($event)"
                onReady
                (autoBind)="bindingHandler($event, 'selectedPK_Employee', multiSelect2)">
              </app-multi-select>
            </app-field-wrapper>
            <!-- Champ Access Cards (multi-select) -->
            <app-field-wrapper property="accessCards">
              <app-multi-select #multiSelect3
                [options]="filteredAccessCardLookup()"
                [placeholder]="'choose-access-cards' | translate"
                [maxItems]="10"
                [isMultiselect]="true"
                [selectedKeys]="selectedAccessCardKeys()"
                (selectedKeysChange)="onAccessCardSelectChange($event)"
                onReady>
              </app-multi-select>
            </app-field-wrapper>
            <!-- Signature (image) -->
            <app-field-wrapper property="signature" label="vues.visit.detail.signature">
              <div class="border rounded p-2 bg-gray-50">
                @if (signatureUrl()) {
                <img [src]="rootUrl + signatureUrl()" alt="Signature" class="max-h-32 object-contain">
                } @else {
                <span class="text-gray-400">{{ 'vues.visit.detail.no-signature' | translate }}</span>
                }
              </div>
            </app-field-wrapper>
          </div>
        </div>
      </fieldset>
    </div>
  </div>
  <!-- Bandeau d'erreurs -->
  @if (generalErrorCount() > 0) {
  <div class="mb-1 p-1 bg-orange-100 text-red-700 border border-orange-300 rounded-full text-xs sticky bottom-14 z-10 py-1 -mt-1 z-20 text-center">
    <i class="fas fa-exclamation-triangle mr-1 ml-2"></i>
    {{ generalErrorCount() }} erreur(s) dans le formulaire
  </div>
  }
  <!-- Boutons -->
  <div class="bg-stone-50 min-w-full flex space-x-1 justify-center pt-2 border-t border-gray-200">
    @if (HasEditPermission) {
    <button name="SaveButton" data-testid="detail-save"
      type="button" (click)="saveItem()"
      [disabled]="!isFormValid()"
      class="{{Skin.btnPrimary}} uppercase py-2 px-2">
      <i class="far fa-check-square mr-2"></i>
      {{ 'buttons.save' | translate }}
    </button>
    }
    @if (HasEditPermission) {
    <button name="SaveAndCloseButton" data-testid="detail-save-close"
      type="button" (click)="saveAndCloseItem()"
      [disabled]="!isFormValid()"
      class="{{Skin.btnPrimary}} uppercase py-2 px-2">
      <i class="far fa-check-square mr-2"></i>
      {{ 'buttons.save-and-close' | translate }}
    </button>
    }
    <button (click)="cancelEdit()" data-testid="detail-cancel" class="{{Skin.btnAlert}} uppercase py-2 px-2">
      <i class="fas fa-times mr-2"></i>
      {{ 'buttons.cancel' | translate }}
    </button>
  </div>
</div>
}
}